import config from "../../config"

export const SIGNALING_CONFIG = {
  serverUrl: config.url,
}